import { css } from '@emotion/css';

import { Spacing } from 'apps/shared/scripts/styles/constants';

export const buttonClassName = css({
  height: 42,
  marginRight: Spacing.MD,
  padding: Spacing.SM,
  width: 42,
});
